import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Autorizacao from '../../security/Autorizacao'
import {
  PERFIL_ADMIN,
  getAdminEmpresa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getVendedorEmpresa,
  getFinanceiroEmpresa,
  getFinanceiroCaixa,
  getFinanceiroAgencia,
  getMotoristaEmpresa,
  getFiscalEmbarque,
  getGestorOperacoes,
  getOperadorRemarcacao,
  getPerfisVendedores,
  getUsuarioHabilitadoVendaOffline,
  hasPerfil
} from '../../security/securityContext'
import { getEmpresaSelecionada, removeEmpresaSelecionada } from '../../util/empresaSelecionada'
import limparViagens from '../../actions/viagem/limpaViagens'
import selecionarReservasRemarcacao from '../../actions/remarcacao/selecionarReservasRemarcacao'
import { logoutUser } from '../../actions/util/authenticationJwtActions'

export class Sidebar extends Component {
  state = {
    sectionsOpen: {
      operacoes: true,
      gestao: true,
      financeiro: true,
      fiscal: true,
      administracao: true,
      configuracoes: true,
    }
  }

  toggleSection = (key) => {
    this.setState(prev => ({
      sectionsOpen: { ...prev.sectionsOpen, [key]: !prev.sectionsOpen[key] }
    }))
  }

  handleLogout = () => {
    this.props.logoutUser()
    removeEmpresaSelecionada()
    this.props.history.replace('/login')
  }

  renderSection (key, label) {
    const isOpen = this.state.sectionsOpen[key]
    return (
      <div
        className="vx-sidebar-section vx-sidebar-section--toggle"
        onClick={() => this.toggleSection(key)}
      >
        <span>{label}</span>
        <i className="material-icons vx-sidebar-section-icon">
          {isOpen ? 'expand_less' : 'expand_more'}
        </i>
      </div>
    )
  }

  isActive (path) {
    return this.props.location && this.props.location.pathname === path
  }

  isActivePrefix (prefix) {
    return this.props.location && this.props.location.pathname.startsWith(prefix)
  }

  renderLink (to, icon, label, onClick) {
    const active = this.isActive(to) || this.isActivePrefix(to + '?')
    return (
      <li className="vx-sidebar-item">
        <Link
          to={to}
          className={`vx-sidebar-link${active ? ' vx-active' : ''}`}
          onClick={onClick}
        >
          <i className="material-icons">{icon}</i>
          <span className="vx-sidebar-label">{label}</span>
        </Link>
      </li>
    )
  }

  render () {
    const { authentication, empresaSelecionada, isOpen } = this.props

    if (!authentication || !authentication.isAuthenticated) {
      return null
    }

    const emp = empresaSelecionada || {}
    const isAdmin = hasPerfil(PERFIL_ADMIN)
    const offlineMode = !this.props.online

    return (
      <>
        {/* Overlay mobile */}
        <div
          className={`vx-sidebar-overlay${isOpen ? ' vx-sidebar-overlay--visible' : ''}`}
          onClick={this.props.onClose}
        />

        <nav className={`vx-sidebar${isOpen ? '' : ' vx-sidebar--closed'}`}>
          {/* Logo */}
          <div className="vx-sidebar-logo">
            <span className="vx-sidebar-logo-text">vexado</span>
          </div>

          <ul className="vx-sidebar-menu">
            {offlineMode && (
              <li className="vx-sidebar-offline-badge">
                <i className="material-icons">wifi_off</i>
                <span>Modo Offline</span>
              </li>
            )}

            {/* Dashboard */}
            {!offlineMode && (
              <li className="vx-sidebar-item">
                <Link
                  to={isAdmin ? '/gestao' : '/gestao-empresa'}
                  className={`vx-sidebar-link${(this.isActive('/gestao-empresa') || this.isActive('/gestao')) ? ' vx-active' : ''}`}
                >
                  <i className="material-icons">dashboard</i>
                  <span className="vx-sidebar-label">Dashboard</span>
                </Link>
              </li>
            )}

            {/* ── Seção Operações ── */}
            {this.renderSection('operacoes', 'Operações')}

            {this.state.sectionsOpen.operacoes && (
              <>
                {/* 1. Vender Passagens */}
                {(emp.habilitadoAcessoPassagens || isAdmin) && (
                  <Autorizacao
                    perfisPermitidos={[...getPerfisVendedores(emp.id), PERFIL_ADMIN]}
                    empresaSelecionada={emp}
                  >
                    <li className="vx-sidebar-item">
                      <Link
                        to="/painel-destinos"
                        className={`vx-sidebar-link${this.isActivePrefix('/painel-destinos') ? ' vx-active' : ''}`}
                        onClick={() => {
                          this.props.limparViagens()
                          this.props.selecionarReservasRemarcacao(null)
                        }}
                      >
                        <i className="material-icons">monetization_on</i>
                        <span className="vx-sidebar-label">Vender Passagens</span>
                      </Link>
                    </li>
                  </Autorizacao>
                )}

                {/* 2. Passagens Vendidas */}
                {!offlineMode && (emp.habilitadoAcessoPassagens || isAdmin) && (
                  <Autorizacao
                    perfisPermitidos={[
                      PERFIL_ADMIN,
                      getOperadorEmpresa(emp.id),
                      getGestorEmpresa(emp.id),
                      getFinanceiroCaixa(emp.id),
                      getFinanceiroAgencia(emp.id),
                      ...getPerfisVendedores(emp.id)
                    ]}
                    empresaSelecionada={emp}
                  >
                    {this.renderLink('/painel-vendas', 'shopping_cart', 'Passagens Vendidas')}
                  </Autorizacao>
                )}

                {(emp.habilitadoAcessoPassagens || isAdmin) && getUsuarioHabilitadoVendaOffline(emp.id) && (
                  <li className="vx-sidebar-item">
                    {this.renderLink('/painel-vendas-offline', 'sync', 'Vendas Offline')}
                  </li>
                )}

                {/* 2b. Vendas Urbanas */}
                {emp.habilitadoVendaUrbana && (
                  <Autorizacao
                    perfisPermitidos={[
                      PERFIL_ADMIN,
                      getAdminEmpresa(emp.id),
                      getOperadorRemarcacao(emp.id),
                      ...getPerfisVendedores(emp.id)
                    ]}
                    empresaSelecionada={emp}
                  >
                    <li className="vx-sidebar-item">
                      {this.renderLink('/painel-vendas-urbanas', 'directions_walk', 'Vendas Urbanas')}
                    </li>
                    <li className="vx-sidebar-item">
                      {this.renderLink('/painel-vendas-urbanas-offline', 'sync', 'Vendas Urbanas Offline')}
                    </li>
                  </Autorizacao>
                )}

                {/* 2c. Encomenda Avulsa */}
                {emp.habilitadoEncomendaAvulsa && (
                  <Autorizacao
                    perfisPermitidos={[
                      PERFIL_ADMIN,
                      getAdminEmpresa(emp.id),
                      getOperadorEmpresa(emp.id),
                      getOperadorRemarcacao(emp.id),
                      ...getPerfisVendedores(emp.id)
                    ]}
                    empresaSelecionada={emp}
                  >
                    <li className="vx-sidebar-item">
                      {this.renderLink('/painel-cadastro-encomenda-avulsa', 'local_shipping', 'Vender Encomenda Avulsa')}
                    </li>
                    <li className="vx-sidebar-item">
                      {this.renderLink('/painel-encomendas-avulsas', 'archive', 'Encomenda Avulsa')}
                    </li>
                    <li className="vx-sidebar-item">
                      {this.renderLink('/painel-encomendas-avulsas-offline', 'sync', 'Encomenda Avulsa Offline')}
                    </li>
                  </Autorizacao>
                )}

                {/* 3. Bagagem Extra */}
                {!offlineMode && (
                  <Autorizacao
                    perfisPermitidos={[
                      PERFIL_ADMIN,
                      getGestorEmpresa(emp.id),
                      getOperadorEmpresa(emp.id),
                      getFinanceiroEmpresa(emp.id),
                      getFinanceiroCaixa(emp.id),
                      getFinanceiroAgencia(emp.id),
                      ...getPerfisVendedores(emp.id)
                    ]}
                    empresaSelecionada={emp}
                  >
                    {this.renderLink('/menu-bagagem', 'business_center', 'Bagagem Extra')}
                  </Autorizacao>
                )}

                {/* 4. Encomendas Vexado Express */}
                {!offlineMode && ((emp.habilitadoEncomenda && emp.habilitadoAcessoEncomenda) || isAdmin)
                  ? (
                    <Autorizacao
                      perfisPermitidos={[
                        PERFIL_ADMIN,
                        getGestorEmpresa(emp.id),
                        getOperadorEmpresa(emp.id),
                        getFinanceiroEmpresa(emp.id),
                        getFinanceiroCaixa(emp.id),
                        getFinanceiroAgencia(emp.id),
                        ...getPerfisVendedores(emp.id)
                      ]}
                      empresaSelecionada={emp}
                    >
                      {this.renderLink('/menu-encomendas', 'local_shipping', 'Encomendas Vexado Express')}
                    </Autorizacao>
                  )
                  : null
                }

                {/* 5. Remarcar/Cancelar */}
                {!offlineMode && !emp.habilitadoBuscaReservaComBpe && (
                  <Autorizacao
                    perfisPermitidos={[
                      getAdminEmpresa(emp.id),
                      getOperadorRemarcacao(emp.id),
                      PERFIL_ADMIN
                    ]}
                    empresaSelecionada={emp}
                  >
                    {this.renderLink('/painel-remarcacao', 'autorenew', 'Remarcar/Cancelar')}
                  </Autorizacao>
                )}

                {/* 6. Fechamento de Caixa */}
                {!offlineMode && !emp.habilitadoBuscaReservaComBpe && (
                  <Autorizacao
                    perfisPermitidos={[
                      PERFIL_ADMIN,
                      getOperadorEmpresa(emp.id),
                      getFinanceiroAgencia(emp.id),
                      getGestorEmpresa(emp.id),
                      getFinanceiroCaixa(emp.id),
                      ...getPerfisVendedores(emp.id)
                    ]}
                    empresaSelecionada={emp}
                  >
                    {this.renderLink('/menu-fechamento-caixa', 'payment', 'Fechamento de Caixa')}
                  </Autorizacao>
                )}
              </>
            )}

            {/* ── Seção Gestão ── */}
            {!offlineMode && this.renderSection('gestao', 'Gestão')}

            {!offlineMode && this.state.sectionsOpen.gestao && (
              <>
                <Autorizacao
                  perfisPermitidos={[
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id),
                    PERFIL_ADMIN
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-usuarios', 'person', 'Usuários')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getGestorEmpresa(emp.id),
                    getOperadorEmpresa(emp.id),
                    getAdminEmpresa(emp.id),
                    getGestorOperacoes(emp.id),
                    getMotoristaEmpresa(emp.id),
                    getFiscalEmbarque(emp.id),
                    ...getPerfisVendedores(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/menu-itinerario', 'directions', 'Itinerários')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorOperacoes(emp.id),
                    getOperadorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-rotas', 'device_hub', 'Rotas')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    getOperadorEmpresa(emp.id),
                    getGestorEmpresa(emp.id),
                    getGestorOperacoes(emp.id),
                    ...getPerfisVendedores(emp.id),
                    PERFIL_ADMIN
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-valores', 'local_atm', 'Valores')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id),
                    getOperadorEmpresa(emp.id),
                    getVendedorEmpresa(emp.id),
                    getGestorOperacoes(emp.id),
                    getOperadorRemarcacao(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-trechos', 'compare_arrows', 'Trechos')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id),
                    getOperadorEmpresa(emp.id),
                    getGestorOperacoes(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-pontos-embarque', 'location_on', 'Pontos de Embarque')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getOperadorEmpresa(emp.id),
                    getGestorOperacoes(emp.id),
                    getFiscalEmbarque(emp.id)
                  ]}
                >
                  {this.renderLink('/painel-veiculos', 'directions_bus', 'Veículos')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id),
                    getOperadorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-agencia', 'store_mall_directory', 'Agências')}
                </Autorizacao>
              </>
            )}

            {/* ── Seção Financeiro ── */}
            {!offlineMode && this.renderSection('financeiro', 'Financeiro')}

            {!offlineMode && this.state.sectionsOpen.financeiro && (
              <>
                {!emp.habilitadoBuscaReservaComBpe && (
                  <Autorizacao
                    perfisPermitidos={[
                      PERFIL_ADMIN,
                      getOperadorEmpresa(emp.id),
                      getGestorEmpresa(emp.id),
                      getAdminEmpresa(emp.id),
                      getFinanceiroAgencia(emp.id),
                      getFinanceiroCaixa(emp.id),
                      getFinanceiroEmpresa(emp.id),
                      getFiscalEmbarque(emp.id)
                    ]}
                    empresaSelecionada={emp}
                  >
                    {this.renderLink('/menu-relatorio', 'insert_chart', 'Relatórios')}
                  </Autorizacao>
                )}

                <Autorizacao
                  perfisPermitidos={[
                    getAdminEmpresa(emp.id),
                    getFinanceiroEmpresa(emp.id),
                    PERFIL_ADMIN
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-vexado-bi', 'trending_up', 'VexBI')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id),
                    getFinanceiroEmpresa(emp.id),
                    getFinanceiroCaixa(emp.id),
                    getOperadorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/painel-centro-custo', 'receipt', 'Centro de Custo')}
                </Autorizacao>
              </>
            )}

            {/* ── Seção Fiscal ── */}
            {!offlineMode && this.renderSection('fiscal', 'Fiscal')}

            {!offlineMode && this.state.sectionsOpen.fiscal && (
              <>
                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/menu-cteos', 'dvr', 'CT-e OS')}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/menu-mdfe', 'description', 'MDF-e')}
                </Autorizacao>
              </>
            )}

            {/* ── Seção Admin ── */}
            {!offlineMode && isAdmin && (
              <>
                {this.renderSection('administracao', 'Administração')}
                {this.state.sectionsOpen.administracao && (
                  <>
                    {this.renderLink('/painel-empresas',           'business',           'Empresas')}
                    {this.renderLink('/painel-gerencial',          'trending_up',        'Gerencial')}
                    {this.renderLink('/painel-vendas',             'confirmation_number','Passagens Vendidas')}
                    {this.renderLink('/painel-cidades',            'location_city',      'Cidades')}
                    {this.renderLink('/painel-mapas-veiculos',     'directions_bus',     'Mapas de Veículos')}
                    {this.renderLink('/menu-usuario',              'group',              'Usuários')}
                    {this.renderLink('/interessados-promocao',     'supervisor_account', 'Interessados e Clientes')}
                    {this.renderLink('/painel-cupons',             'local_offer',        'Cupons')}
                    {this.renderLink('/menu-adesao-pontos',        'stars',              'Adesão de pontos')}
                    {this.renderLink('/painel-repasse-venda',      'account_balance',    'Repasse Venda')}
                    {this.renderLink('/painel-remarcacao',         'autorenew',          'Remarcar/Cancelar passagem')}
                    {this.renderLink('/painel-vexado-bi',          'equalizer',          'VexBI')}
                    {this.renderLink('/painel-relatorio-gerencial','assessment',         'Relatório Gerencial')}
                    {this.renderLink('/painel-monitor-sefaz',      'computer',           'Monitor SEFAZ')}
                  </>
                )}
              </>
            )}

            {/* ── Seção Configurações ── */}
            {!offlineMode && this.renderSection('configuracoes', 'Configurações')}

            {!offlineMode && this.state.sectionsOpen.configuracoes && (
              <>
                {/* Configuração Empresa – item destacado */}
                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  <li className="vx-sidebar-item">
                    <Link
                      to="/painel-configuracao-empresa"
                      className={`vx-sidebar-link vx-sidebar-link--empresa${this.isActive('/painel-configuracao-empresa') ? ' vx-active' : ''}`}
                    >
                      <i className="material-icons">tune</i>
                      <span className="vx-sidebar-label">Configuração Empresa</span>
                      <span className="vx-sidebar-empresa-tag">Setup</span>
                    </Link>
                  </li>
                </Autorizacao>

                <div className="vx-sidebar-empresa-divider" />

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getGestorEmpresa(emp.id),
                    getAdminEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink(
                    `/painel-configuracao-bilhete?codigoEmpresa=${emp.id}&pagina=gestao`,
                    'confirmation_number',
                    'Config. Bilhete'
                  )}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getGestorEmpresa(emp.id),
                    getAdminEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink(
                    `/painel-configuracao-bpe?codigoEmpresa=${emp.id}&habilitadaBPe=${emp.habilitadoBpe}&pagina=gestao`,
                    'business',
                    'Config. BPe'
                  )}
                </Autorizacao>

                <Autorizacao
                  perfisPermitidos={[
                    PERFIL_ADMIN,
                    getAdminEmpresa(emp.id),
                    getGestorEmpresa(emp.id)
                  ]}
                  empresaSelecionada={emp}
                >
                  {this.renderLink('/menu-adesao-pontos-empresa', 'stars', 'Adesão de Pontos')}
                </Autorizacao>

                <li className="vx-sidebar-item">
                  <Link to="/gestao-empresa" className="vx-sidebar-link">
                    <i className="material-icons">help_outline</i>
                    <span className="vx-sidebar-label">Ajuda</span>
                  </Link>
                </li>
              </>
            )}
          </ul>

          {/* Atalhos rápidos */}
          {!offlineMode && <div className="vx-sidebar-bottom">
            <div className="vx-sidebar-bottom-header">
              <span className="vx-sidebar-bottom-title">Atalhos rápidos</span>
            </div>

            <Autorizacao
              perfisPermitidos={[...getPerfisVendedores(emp.id), PERFIL_ADMIN]}
              empresaSelecionada={emp}
            >
              <Link
                to="/painel-destinos"
                className="vx-shortcut-btn"
                onClick={() => {
                  this.props.limparViagens()
                  this.props.selecionarReservasRemarcacao(null)
                }}
              >
                <i className="material-icons">monetization_on</i>
                Nova venda
              </Link>
            </Autorizacao>

            <Autorizacao
              perfisPermitidos={[...getPerfisVendedores(emp.id), PERFIL_ADMIN]}
              empresaSelecionada={emp}
            >
              <Link to="/painel-vendas" className="vx-shortcut-btn">
                <i className="material-icons">receipt</i>
                Emitir passagem
              </Link>
            </Autorizacao>

            <button
              type="button"
              className="vx-logout-btn"
              onClick={this.handleLogout}
            >
              <i className="material-icons">power_settings_new</i>
              Sair do sistema
            </button>
          </div>}

          <div className="vx-sidebar-footer">
            © 2024 Vexado Sistemas
          </div>
        </nav>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  empresaSelecionada: state.empresaSelecionada || getEmpresaSelecionada(),
  online: state.conexao ? state.conexao.online : true
})

export default withRouter(
  connect(mapStateToProps, { limparViagens, selecionarReservasRemarcacao, logoutUser })(Sidebar)
)
